var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MenuContainer"},[(_vm.curWorkPath)?_c('b-menu-container',{attrs:{"argument":_vm.bMenuContainer}}):_c('div',[_vm._v(" 无路由 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }